<template>
  <v-container>
    <h1>SafeSyte beheer</h1>
    <v-card>
      <v-card-title>Gebruikerbeheer</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item to="/beheer/gebruikers">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>Gebruikers
          </v-list-item>
                    <v-list-item to="/beheer/profielen">
            <v-list-item-icon>
              <v-icon>mdi-face-profile</v-icon>
            </v-list-item-icon>Profielen
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {};
</script>